import React from "react";

export default function Logo({ className = "", size = "normal" }) {
  const sizeClasses = {
    small: "h-6 w-auto",
    normal: "h-8 w-auto",
    large: "h-12 w-auto",
  };

  return (
    <img
      src="/logo.svg"
      alt="Bill Forge"
      className={`${sizeClasses[size]} ${className}`}
      style={{ maxWidth: '200px' }}
    />
  );
}

export function TextLogo({ className = "" }) {
  return (
    <span className={`font-extrabold tracking-tighter ${className}`}>
      BILL FORGE
    </span>
  );
}